<template>
  <v-app>
    <v-container fluid grid-list-lg>
      <v-card>
        <v-app-bar flat>
          <v-icon>group</v-icon>
          <v-toolbar-title class="font-weight-light"
            >&nbsp;ABM de Usuarios</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                icon
                color="red"
                v-on="on"
                @click="setStatusTareaFrecuente(action)"
              >
                <v-icon v-if="action.esFrecuente">favorite</v-icon>
                <v-icon v-else>favorite_border</v-icon>
              </v-btn>
            </template>
            <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
            <span v-else>Agregar a Tareas Frecuentes</span>
          </v-tooltip>
        </v-app-bar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 sm6 md6 lg6>
              <v-card>
                <v-app-bar
                  flat
                  dense
                  :color="$store.state.UiColors.crudToolbarList"
                >
                  <v-icon>list</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Lista</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                </v-app-bar>

                <v-flex right>
                  <v-row>
                    <v-flex sm11>
                      <v-text-field
                        v-if="!searchFilter"
                        v-model="search"
                        append-icon="search"
                        label="Buscar por Nombre"
                        single-line
                        hide-details
                      ></v-text-field>
                      <v-text-field
                        v-if="searchFilter"
                        v-model="search"
                        append-icon="search"
                        label="Buscar por Login"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-flex>
                    <v-flex sm1>
                      <v-switch v-model="searchFilter"></v-switch>
                    </v-flex>
                  </v-row>
                </v-flex>

                <v-data-table
                  :headers="headers"
                  :items="records"
                  :server-items-length="totalItems"
                  :loading="loading"
                  :options.sync="options"
                  v-model="selectedRow"
                  :footer-props="{
                    itemsPerPageOptions: options.rowsPerPageItems,
                  }"
                >
                  <template v-slot:no-data>
                    <v-alert :value="true" color="grey" icon="warning">
                      No se encontraron datos
                    </v-alert>
                  </template>

                  <template v-slot:item="{ item }">
                    <tr @click="viewItem(item)">
                      <td class="text-xs-left">
                        {{ item.nombre }}
                        <v-chip small label v-if="item.baja" color="error"
                          >Anulado</v-chip
                        >
                      </td>
                      <td class="text-xs-left">{{ item.login }}</td>
                      <td class="text-xs-left">
                        <v-icon
                          small
                          class="mr-2"
                          @click="editItem(item)"
                          v-show="canUpdate"
                          >edit</v-icon
                        >
                        <v-icon
                          small
                          @click="deleteItem(item)"
                          v-show="canDelete"
                          >delete</v-icon
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
              <v-row dense>
                <v-col cols="4" class="mt-4">
                  <v-btn color="info" @click="procesarBase()"
                    >Exportar Listado</v-btn
                  >
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="separador"
                    label="Separador"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-flex>

            <v-flex xs12 sm6 md6 lg6>
              <v-card>
                <v-app-bar
                  flat
                  dense
                  :color="$store.state.UiColors.crudToolbarList"
                >
                  <v-icon>perm_identity</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Detalle</v-toolbar-title
                  >
                  <v-spacer></v-spacer>

                  <v-btn
                    v-if="!editMode"
                    :color="$store.state.UiColors.crudToolbarDetailButtons"
                    fab
                    small
                    top
                    @click="editItem()"
                    v-show="canCreate"
                  >
                    <v-icon medium>add_circle_outline</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="model.id != null"
                    :color="$store.state.UiColors.crudToolbarDetailButtons"
                    fab
                    small
                    top
                    @click="editMode = !editMode"
                    v-show="canUpdate"
                  >
                    <v-icon v-if="editMode">cancel</v-icon>
                    <v-icon v-else>edit</v-icon>
                  </v-btn>
                </v-app-bar>
                <v-card-text>
                  <v-form :disabled="!editMode">
                    <v-layout row wrap>
                      <v-flex d-flex xs12 sm6 md4>
                        <div>
                          <v-avatar
                            :disabled="!editMode"
                            size="150px"
                            v-ripple
                            v-if="!imagenPerfil.url"
                            class="grey lighten-3 mb-3"
                            @click="openFileDialog()"
                          >
                            <span
                              >Clickee para agregar una imagen de perfil</span
                            >
                          </v-avatar>
                          <v-avatar
                            :disabled="!editMode"
                            size="150px"
                            v-ripple
                            v-else
                            class="mb-3"
                            @click="openFileDialog()"
                          >
                            <img v-bind:src="imagenPerfil.url" />
                          </v-avatar>
                          <input
                            :disabled="!editMode"
                            type="file"
                            id="file-upload"
                            style="display: none"
                            @change="onFileChange"
                          />
                        </div>
                      </v-flex>

                      <v-flex d-flex xs12 sm6 md8>
                        <v-layout row wrap>
                          <v-flex xs4>
                            <v-text-field
                              v-model="model.login"
                              label="Login"
                              :disabled="!editMode"
                              v-validate="'required'"
                              data-vv-name="login"
                              :error-messages="errors.collect('login')"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              v-model="model.nombre"
                              label="Nombre"
                              :disabled="!editMode"
                              v-validate="'required'"
                              data-vv-name="nombre"
                              :error-messages="errors.collect('nombre')"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs2 v-if="model.status && model.status.baja">
                            <v-chip
                              label
                              :color="model.status.baja ? 'error' : 'info'"
                              >{{
                                model.status.baja ? 'Anulado' : 'Activo'
                              }}</v-chip
                            >
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex d-flex xs12>
                        <v-layout wrap>
                          <v-flex>
                            <v-switch
                              label="Es Comer"
                              v-model="model.esComer"
                              :disabled="!editMode"
                            ></v-switch>
                          </v-flex>
                          <v-flex>
                            <v-switch
                              label="Es Online"
                              v-model="model.esOnline"
                              :disabled="!editMode"
                            ></v-switch>
                          </v-flex>
                          <v-flex>
                            <v-switch
                              label="Es Concentrador"
                              v-model="model.esConcentrador"
                              :disabled="!editMode"
                            ></v-switch>
                          </v-flex>
                          <v-flex>
                            <v-switch
                              label="Es Comercio"
                              v-model="model.esComercio"
                              :disabled="!editMode"
                            ></v-switch>
                          </v-flex>
                          <v-flex>
                            <v-switch
                              label="Es Sucu"
                              v-model="model.esSucursal"
                              :disabled="!editMode"
                            ></v-switch>
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex d-flex xs12>
                        <v-layout wrap>
                          <v-flex>
                            <v-select
                              :items="tipoModalidadAltaConsulta"
                              v-model="model.modalidadAltaConsultaId"
                              item-text="descripcion"
                              item-value="id"
                              label="Modalidad para el Alta de Consulta"
                              :disabled="!editMode"
                            ></v-select>
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex d-flex xs12>
                        <v-layout wrap>
                          <v-flex>
                            <v-layout>
                              <v-flex xs6>
                                <v-switch
                                  label="Puede Autorizar"
                                  v-model="model.puedeAutorizar"
                                  :disabled="!editMode"
                                >
                                  <template v-slot:append>
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-icon v-on="on">info</v-icon>
                                      </template>
                                      Si se activa, el usuario podrá realizar
                                      autorizaciones por excepción. Deberá
                                      configurar su CAR (Código de Autorización
                                      Rápido) personalmente.
                                    </v-tooltip>
                                  </template>
                                </v-switch>
                              </v-flex>
                              <v-flex xs4>
                                <v-text-field
                                  v-if="model.puedeAutorizar"
                                  v-model="model.car"
                                  label="Código de Autorización Rápida (CAR)"
                                  :disabled="!editMode"
                                  data-vv-name="CAR"
                                  :error-messages="errors.collect('CAR')"
                                  counter
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="model.email"
                          label="Email"
                          :disabled="!editMode"
                          v-validate="'email'"
                          data-vv-name="email"
                          :error-messages="errors.collect('email')"
                        ></v-text-field>
                          <v-text-field
                          v-model="model.emailValidacion"
                          label="Email Validación"
                          :disabled="!editMode"
                          v-validate="'email'"
                          data-vv-name="emailValidacion"
                          :error-messages="errors.collect('emailValidacion')"
                        ></v-text-field>
                        <!--<v-select
                          :items="roles"
                          v-model="model.roles"
                          item-text="descripcion"
                          item-value="id"
                          label="Roles"
                          multiple
                          :disabled="!editMode"
                          search-input
                        ></v-select> 
                        <v-autocomplete
                        :items="roles"
                          v-model="model.roles"
                          item-text="descripcion"
                          item-value="id"
                          label="Roles"
                          multiple
                          :disabled="!editMode"
                          search-input
                          auto-select-first
                          chips
                          clearable
                          deletable-chips
                          small-chips
                        ></v-autocomplete> -->

                        <v-autocomplete
                          v-model="model.roles"
                          :disabled="!editMode"
                          :items="roles"
                          filled
                          chips
                          color="blue-grey lighten-2"
                          background-color="white"
                          label="Roles"
                          item-text="descripcion"
                          item-value="id"
                          multiple
                         ></v-autocomplete>
                      </v-col>
                      <v-col>
                        <v-select
                          :items="tiposSectoresUsuario"
                          v-model="model.sectorId"
                          item-text="descripcion"
                          item-value="id"
                          label="Sector"
                          :disabled="!editMode"
                        ></v-select>
                      </v-col>
                    </v-row>

                    <v-row
                      v-if="model.roles && model.roles.find((r) => r == 4)"
                    >
                      <v-col>
                        <v-select
                          :items="tipoGestion"
                          v-model="model.tipoGestionId"
                          item-text="descripcion"
                          item-value="id"
                          label="Sector"
                          :disabled="!editMode"
                        ></v-select>
                      </v-col>

                      <v-col>
                        <v-switch
                          label="Puede Autoasignarse Casos"
                          v-model="model.puedeTomarCasoGestion"
                          :disabled="!editMode"
                        >
                          <template v-slot:append>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on">info</v-icon>
                              </template>
                              Si se activa, el usuario podrá tomar casos para
                              gestionar, quedando los mismos asignados a él.
                            </v-tooltip>
                          </template>
                        </v-switch>
                      </v-col>
                    </v-row>

                    <v-select
                      :items="empresas"
                      v-model="model.empresas"
                      item-text="nombre"
                      item-value="id"
                      label="Empresas a las que puede acceder"
                      multiple
                      :disabled="!editMode"
                    ></v-select>

                    <v-flex xs12>
                      <v-switch
                        label="Permir Acceso a todos los Canales de Venta"
                        v-model="model.accesoTodosCanalesVenta"
                        :disabled="!editMode"
                        :hint="
                          model.accesoTodosCanalesVenta
                            ? 'Puede operar con Todos los Canales de Venta'
                            : ''
                        "
                        persistent-hint
                      ></v-switch>
                    </v-flex>

                    <app-lista-doble
                      label="Puede operar con los siguientes Canales de Venta"
                      :enabled="editMode"
                      :items="canalesVentaDisponibles"
                      :selectedItems="model.canalesVenta"
                      v-model="model.canalesVenta"
                      v-show="!model.accesoTodosCanalesVenta"
                      :headers="[
                        { text: 'Empresa', value: 'empresaDescripcion' },
                        { text: 'Descripcion', value: 'nombre' },
                      ]"
                    >
                    </app-lista-doble>

                    <template v-if="$store.state.debugModeOn">
                      Debug Info:
                      <p></p>

                      Model: {{ model }}
                    </template>
                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-btn
                        color="success"
                        :disabled="
                          !editMode ||
                          this.model.id ===
                            '00000000-0000-0000-0000-000000000000'
                        "
                        @click="blanquearPass"
                        ><v-icon></v-icon>Blanquear Clave</v-btn
                      >
                      <v-btn
                        color="error"
                        :disabled="
                          !editMode ||
                          this.model.id ===
                            '00000000-0000-0000-0000-000000000000'
                        "
                        @click="baja"
                        ><v-icon></v-icon>Dar de Baja</v-btn
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        color="success"
                        :disabled="!editMode"
                        @click="saveItem"
                        ><v-icon>save</v-icon>Guardar</v-btn
                      >
                    </v-card-actions>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import { http } from '@/axios';
import Vue from 'vue';

import sha256 from 'crypto-js/sha256';
import encHex from 'crypto-js/enc-hex';
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

export default {
  data() {
    return {
      loading: false,
      editMode: false,
      suspend: false,
      search: '', // valor para búsqueda
      options: {
        // definición de paginación
        sortDesc: [false],
        sortBy: [''],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems: [5, 10, 20],
      },
      totalItems: 0, // va afuera de pagination
      headers: [
        // definición de columnas
        { text: 'Nombre', value: 'nombre' },
        { text: 'Login', value: 'login' },
        { text: 'Acciones', value: 'action', sortable: false },
      ],
      records: [], // registros
      selectedRow: [],
      model: { status: {} }, // registro para ver/editar
      searchFilter: false,
      roles: [],
      empresas: [],
      canalesVenta: [],
      tipoGestion: [],
      tipoModalidadAltaConsulta: [],
      imagenPerfil: { file: null, url: '' },
      tiposSectoresUsuario: [],
      separador: ';',
    };
  },
  async created() {
    this.loadRoles();
    this.loadEmpresas();
    this.loadCanalesVenta();
    this.loadTiposGestion();
    this.loadTiposModalidadesAltaConsulta();
    this.loadTiposSectorUsuario();
  },
  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
    search() {
      this.getItems();
    },
    'model.empresas': {
      handler() {
        if (!this.model.canalesVenta) return;

        // veo si hay canales de venta de alguna empresa que no está asignada
        var res = this.checkCanalesVentaNoSeleccionadosByEmpresas();

        if (res && res.length > 0) {
          this.alertWarning(
            'Atención, hay ' +
              res.length +
              ' canales de venta asociados a empresa/s que el usuario no tiene acceso. '
          );
        }
      },
    },
  },
  computed: {
    ...mapGetters([
      'checkCanCreate',
      'checkCanUpdate',
      'checkCanDelete',
      'getActionFromLink',
      'error',
    ]),
    canCreate: function () {
      return this.checkCanCreate(this.$route.path);
    },
    canUpdate: function () {
      return this.checkCanUpdate(this.$route.path);
    },
    canDelete: function () {
      return this.checkCanDelete(this.$route.path);
    },
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
    canalesVentaDisponibles: function () {
      if (!this.model.empresas) return [];

      const list = this.canalesVenta.filter((e) =>
        this.model.empresas.includes(e.empresaId)
      );

      return list;
    },
  },
  methods: {
    ...mapMutations([
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    ...mapActions(['setStatusTareaFrecuente']),
    
    checkCanalesVentaNoSeleccionadosByEmpresas() {
      var canalesNoSeleccionados = [];

      for (let i = 0; i < this.model.canalesVenta.length; i++) {
        var canalVenta = this.getCanalVentaById(this.model.canalesVenta[i]);
        if (canalVenta != null) {
          // veo si la empresa del canal de venta está entre las marcadas
          var estaSeleccionada = false;
          for (let j = 0; j < this.model.empresas.length; j++) {
            const empresaId = this.model.empresas[j];
            if (empresaId == canalVenta.empresaId) {
              estaSeleccionada = true;
              break;
            }
          }
          if (!estaSeleccionada) canalesNoSeleccionados.push(canalVenta);
        }
      }
      return canalesNoSeleccionados;
    },
     getTimeBlock() {
      const now = Math.floor(Date.now() / 1000); // segundos UNIX
      return Math.floor(now / 60); // bloque de 1 minuto
    },
    generateValidationCode() {
      const secret = 'dmg_secret_d1g1t4lm1nd3'; // Reemplazar con tu secreto
      const block = this.getTimeBlock();
      const data = `${secret}:${block}`;
      const hash = sha256(data).toString(encHex);
      return hash.substring(0, 6).toUpperCase(); // por ejemplo, 6 caracteres
    },
    getCanalVentaById(canalVentaId) {
      for (let i = 0; i < this.canalesVenta.length; i++) {
        const canalVenta = this.canalesVenta[i];
        if (canalVenta.id == canalVentaId) return canalVenta;
      }
      return null;
    },
    async getItems() {
      this.loading = true;
      this.$validator.reset();

      try {
        var result = await http.get(
          'usuarios?nombre=' +
            this.search +
            '&filtro=' +
            this.searchFilter +
            '&limit=' +
            this.options.itemsPerPage +
            '&page=' +
            this.options.page +
            '&activos=true' +
            '&sortby=' +
            this.options.sortBy +
            '&descending=' +
            (this.options.sortDesc.length > 0 ? this.options.sortDesc : 'false')
        );

        this.records = result.list;
        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async procesarBase() {
      this.loading = true;

      let dataList = [];

      try {
        var result = await http.get(
          'usuarios?nombre=' +
            this.search +
            '&filtro=' +
            this.searchFilter +
            '&limit=' +
            this.totalItems +
            '&page=' +
            this.options.page +
            '&activos=true' +
            '&sortby=' +
            this.options.sortBy +
            '&descending=' +
            (this.options.sortDesc.length > 0 ? this.options.sortDesc : 'false')
        );

        dataList = result.list;

        try {
          let parametros = [];

          for (let i = 0; i < dataList.length; i++) {
            var data = {
              nombre: dataList[i].nombre,
              mail: dataList[i].email,
              login: dataList[i].login,
            };

            parametros.push(data);
          }

          console.log(parametros);

          console.log(this.separador);

          await http
            .post(
              'filegeneration/listausuarios',
              JSON.stringify({
                listUsers: parametros,
                separador: this.separador,
              })
            )
            .then((resp) => {
              console.log(resp);

              if (resp.error) {
                this.alertError(resp.error);
              } else {
                this.alertSuccess(
                  'Se generó correctamente el archivo. Aguarde unos instantese mientras se descarga el archivo...'
                );

                this.loading = true;
                this.downloadFile(resp, 'ListaUsuarios.csv');
                this.loading = false;
              }
            })
            .catch((e) => {
              this.alertError(e);
            });
        } catch (error) {
          console.error(error);
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async downloadFile(file, renameTo) {
      //convierto el string del path a base64 para poder mandarlo
      let base64String = '';
      base64String = btoa(file.fullPath);

      http
        .get('filemanagement/getfilebypath/' + base64String)
        .then((resp) => {
          let dataType = '';
          switch (resp.extension) {
            case '.doc':
            case '.docx':
            case '.DOC':
            case '.DOCX':
              dataType = 'data:application/vnd.ms-word';
              break;
            case '.pdf':
            case '.PDF':
              dataType = 'data:application/pdf';
          }

          //necesito hacer esto del arrayBuffer para que despues se pueda hacer el blob
          var arrayBuffer = this.base64ToArrayBuffer(resp.file);
          this.saveByteArray(renameTo, arrayBuffer, dataType);
        })
        .catch((e) => this.alertError(e));
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      var blob = new Blob([byteArrayBuffer], { type: dataType });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
    async resetState() {
      this.$validator.reset();
      this.editMode = false;
    },
    async getItem(id) {
      this.loading = true;
      this.resetState();

      try {
        var result = await http.get('usuarios/' + id);

        if (result.imagenPerfilBase64) {
          this.base64ToFile(result.imagenPerfilBase64);
        } else {
          this.imagenPerfil.file = null;
          this.imagenPerfil.url = '';
        }

        this.model = result;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async viewItem(item) {
      await this.getItem(item.id);
    },
    async loadRoles() {
      this.loading = true;
      try {
        var result = await http.get('rolesusuario/');

        this.roles = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposGestion() {
      this.loading = true;
      try {
        var result = await http.get('tiposgestion');

        this.tipoGestion = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposModalidadesAltaConsulta() {
      this.loading = true;
      try {
        var result = await http.get('tiposmodalidadesaltaconsulta');

        this.tipoModalidadAltaConsulta = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get('empresas/');

        this.empresas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCanalesVenta() {
      this.loading = true;
      try {
        var result = await http.get('canalesventa?limit=9999');

        this.canalesVenta = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposSectorUsuario() {
      this.loading = true;
      try {
        var result = await http.get('tipossectorusuario');

        this.tiposSectoresUsuario = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async clearAndReload() {
      // Clear the data inside of the form
      this.model = {};
      this.imagenPerfil = { file: null, url: '' };
      this.resetState();

      // Refresco la grilla
      await this.getItems();
    },
    async editItem(item) {
      this.suspend = true; // hago esto porque se dispara también el evento click del row (que llama a viewItem)

      if (!item) await this.getItem('00000000-0000-0000-0000-000000000000');
      //Paso un GUID vacío.
      else await this.getItem(item.id);

      this.editMode = true;
      this.suspend = false;
    },
    async cancelEdit() {
      this.editMode = false;
    },
    async saveItem() {
      const isUpdate = this.model.id !== '00000000-0000-0000-0000-000000000000';
      await this.$validator.validateAll();

      if (this.errors.items.length > 0) return;

      // veo si hay canales de venta de alguna empresa que no está asignada
      var canalesADesmarcar = this.checkCanalesVentaNoSeleccionadosByEmpresas();
      if (canalesADesmarcar.length > 0) {
        var mensaje = '';

        if (canalesADesmarcar.length < 10) {
          mensaje = 'Se perderá el acceso a los siguientes Canales de Venta: ';
          for (let i = 0; i < canalesADesmarcar.length; i++) {
            mensaje = mensaje + canalesADesmarcar[i].nombre + ', ';
          }
        } else {
          mensaje =
            'Se perderá el acceso a ' +
            canalesADesmarcar.length +
            ' Canales de Venta. ¿Confirma continuar?';
        }

        const res = await this.$dialog.confirm({
          text: mensaje,
          title: 'Desasignación de Canales de Venta por Empresa sin Acceso',
          persistent: true, // Parece que no funciona...
        });

        if (!res) return;

        // desmarco los canales de venta
        const toRemove = canalesADesmarcar.map((e) => e.id);
        this.model.canalesVenta = this.model.canalesVenta.filter(
          (e) => !toRemove.includes(e)
        );
      }

      //si hay imagen de perfil seleccionada la convierto a base 64 para mandarla
      if (this.imagenPerfil.file) {
        await this.getBase64(this.imagenPerfil.file).then(
          (res) => (this.model.imagenPerfilBase64 = res)
        );
      }

      if (isUpdate) {
        try {
          let code = this.generateValidationCode();

          await http.put('usuarios', JSON.stringify({ ticket: code, usuario: this.model }));
          this.alertSuccess('Los cambios han sido guardados.');
          this.clearAndReload();
        } catch (error) {
          // Error
          this.alertError(error);
        }
      } else {
        try {
          await http.post('usuarios', JSON.stringify({ usuario: this.model }));
          this.alertSuccess('Los cambios han sido guardados.');
          this.clearAndReload();
        } catch (error) {
          // Error
          this.alertError(error);
        }
      }
    },
    async blanquearPass() {
      if (
        confirm('La contraseña del usuario será reestablecida ¿Está seguro?')
      ) {
        try {
          this.loading = true;
          await http.put('usuarios/blanquearclave/', {
            usuario: { login: this.model.login },
            ticket: '9C463FA0-E471-4483-ABFE-8A0AB9777FC5'
          });
          this.alertSuccess(
            'La clave ha sido blanqueada. El usuario debe ingresar sin clave y luego seguir los pasos.'
          );
          this.cancelEdit();
        } catch (error) {
          // Error
          this.alertError(error);
        }
        this.loading = false;
      }
    },
    async baja() {
      if (
        confirm(
          'Esta acción es irreversible ¿Está seguro que desea dar de Baja al usuario (no podrá ingresar al sistema)?'
        )
      ) {
        try {
          const motivo = prompt('Ingrese el motivo de la baja');
          if (motivo == null) return;

          this.loading = true;

          await http.put('usuarios/baja/', {
            id: this.model.id,
            motivo: motivo,
          });
          this.alertSuccess('El usuario ha sido dado de Baja.');
          this.cancelEdit();
        } catch (error) {
          // Error
          this.alertError(error);
        }

        this.loading = false;
      }
    },
    async deleteItem(item) {
      if (
        confirm('¿Confirma la eliminación del usuario ' + item.nombre + '?')
      ) {
        try {
          await http.delete('usuarios?id=' + item.id);
          this.alertSuccess('El usuario ha sido eliminado.');
          this.clearAndReload();
        } catch (error) {
          // Error
          this.alertError(error);
        }
      }
    },
    openFileDialog() {
      document.getElementById('file-upload').click();
      //Vue.$log.debug(this.model.imagenPerfilBase64)
    },
    onFileChange(e) {
      Vue.$log.debug(e);
      Vue.$log.debug(e.target.files);

      var files = e.target.files || e.dataTransfer.files;
      if (files.length > 0) {
        if (!files[0].type.includes('image')) {
          //Chequeo que el archivo sea de tipo imagen
          this.alertWarning(
            'Debe seleccionar un archivo con formato de imagen.'
          );
          return;
        }

        this.imagenPerfil.file = files[0];
        //URL.revokeObjectURL(this.imagenPerfil.url);
        this.imagenPerfil.url = URL.createObjectURL(files[0]);
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    base64ToFile(url) {
      const fullUrl = 'data:image/png;base64,' + url;
      this.model.imagenPerfilBase64 = '';
      fetch(fullUrl)
        .then((res) => res.blob())
        .then((blob) => {
          const file = new File([blob], 'File name');

          this.imagenPerfil.url = URL.createObjectURL(file);
          this.imagenPerfil.file = file;
        });
    },
  },
};
</script>
